'use client'

import { useState } from 'react'

import { Button } from './button'
import { KeyboardLayout } from './keyboard-layout'

interface FloatingKeyboardProps {
  onKeyPress?: (value: string) => void
  isNumberOnly?: boolean
  type?: string
}

export const FloatingKeyboard = ({
  onKeyPress,
  isNumberOnly = false,
  type = 'text',
}: FloatingKeyboardProps) => {
  const [isNumeric, setIsNumeric] = useState(type === 'number' || type === 'tel')

  return (
    <div>
      {!isNumberOnly && (
        <div className="flex w-full items-center justify-between overflow-hidden border-b border-gray-200/50 bg-gray-50 p-2">
          <div className="grid w-full grid-cols-2 gap-2">
            <Button
              variant={isNumeric ? 'ghost' : 'outline'}
              onClick={() => setIsNumeric(false)}
              className="w-full"
            >
              ABC
            </Button>
            <Button
              variant={isNumeric ? 'outline' : 'ghost'}
              onClick={() => setIsNumeric(true)}
              className="w-full"
            >
              123
            </Button>
          </div>
        </div>
      )}
      <KeyboardLayout onKeyPress={onKeyPress} isNumeric={isNumeric} />
    </div>
  )
}

export default FloatingKeyboard
